<template>
  <div class="shadow"></div>
</template>

<script>
export default {
  name: "RipeavShadow",
}
</script>

<style scoped>
.shadow{
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000;
  z-index: 1;
  -moz-opacity: .55;
  opacity: .55;
}
</style>